<template>
    <section class="downlaod">
        <za-banner></za-banner>
        <div class="download-box">
        <h2 class="titile">更简洁更流畅的体验</h2>
        <div class="tips">立即下载，享受更多权益</div>
        <a href="https://cdn.eaqiang.com/apk/com.excean.dualaid-16022-17-release.apk">
            <div class="btn">立即下载</div>
        </a>
    </div>
    </section>
</template>

<script>
import zaBanner from '@/components/Banner.vue'
export default {
    components:{
        zaBanner
    }
}
</script>
<style scoped>
.download-box{
    text-align: center;
}
.titile {
    font-size: 30px;
    font-weight: 600;
    color:#333;
    margin:30px 0;
}
.tips{
    font-size: 22px;
    font-weight: 600;
    color:#333;
    margin:30px 0;
}
.btn{
    width: 300px;
    height: 50px;
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    color:#ffffff;
    line-height: 50px;
    background: rgb(0, 96, 146);
    margin: 0 auto;
    border-radius: 5px;
    margin-bottom: 400px;
    cursor: pointer;
}
</style>